import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import claimTypes from "../../../constants/claimTypes";
import { useLocalization } from "../../../hooks/useLocalization";
import { ClaimsHeader, FlexClaimRow } from "./styled";
import { FlexRow } from "../../../components/containers/styled";


const ClaimsListView = ({ claimsType, roleClaims, setClaim }) => {
    const { t } = useLocalization();
    const claims = useSelector(state => state.roles.claims);
    const [claimModels, setClaimModels] = useState({});

    useEffect(() => {
        const existingClaims = {};

        claims.forEach(item => {
            if (item.claimType === claimsType) {
                if (!existingClaims[item.claimName]) {
                    existingClaims[item.claimName] = [item];
                }
                else {
                    existingClaims[item.claimName].push(item)
                }
            }
        });

        setClaimModels(existingClaims);
    }, [claims])


    return (
        <>
            {
                Object.entries(claimModels).length ?
                    <>
                        <ClaimsHeader>{claimsType === claimTypes.MODULE_ACCESS ? t("RoleManagement.ModuleClaimsTitle") :
                            claimsType === claimTypes.FIELD_ACCESS ?
                                t("RoleManagement.FieldClaimsTitle") : ""}</ClaimsHeader>
                        <div className="margin10">
                            {
                                Object.entries(claimModels).map(([key, value]) => {
                                    return <FlexClaimRow key={key}>
                                        <div style={{ width: '40%', minWidth: '350px' }}>
                                            <label >{t(`RoleManagement.Claims.${key}`)}</label>
                                        </div>
                                        <div>
                                            {
                                                value.map(cl => {
                                                    const existing = roleClaims.find(ec => cl.applicationClaimId === ec.applicationClaimId);
                                                    const value = !!existing;
                                                    return (
                                                        <FlexRow key={`${key}.${cl.claimValue}`}>
                                                            <input type="checkbox" checked={value} onChange={(e) => setClaim(cl, !value)} style={{ margin: '0 10px', width: 'unset' }} />
                                                            <label>{t(`AccessLevel.${cl.claimValue}`)}</label>
                                                        </FlexRow>

                                                    )
                                                })
                                            }
                                        </div>
                                    </FlexClaimRow>
                                })
                            }
                        </div>
                    </> :
                    <></>
            }
        </>

    )
}


export default ClaimsListView;